<script lang="ts">
    import '$src/app.css';
    import { dev } from '$app/environment';
    import { inject } from '@vercel/analytics';
    import { page } from '$app/stores';
    import { initAnalytics, trackPageView } from '$lib/analytics/analytics';

    initAnalytics();
    $: $page.url.pathname && trackPageView();
    inject({ mode: dev ? 'development' : 'production' });
</script>

<div class="bg-paper-purple flex">
    <slot />
</div>
